'use client';
import {cn} from '@/lib/utils';
import parse from 'html-react-parser';

export default function ImageText(Prop: {moduleOption: any}) {
  const options = Prop.moduleOption || {};
  const templateItems = options?.items || [];

  return (
    <>
      {templateItems.map((templateItem: any, index: number) => (
        <div className="mb-[24px] md:mb-[40px]" key={index}>
          <img
            className={cn(
              templateItem.imgClass,
              'w-full mb-[24px] md:mb-0 md:w-[45%] object-cover',
              templateItem.isReversed
                ? 'md:float-right md:ml-[48px]'
                : 'md:float-left md:mr-[48px]'
            )}
            src={templateItem.image}
            alt="image"
          />
          <div
            className={cn(
              'text-[#363636] text-[14px] leading-[24px]',
              'md:font-[300] md:text-[16px] md:leading-[28px]'
            )}
          >
            {parse(templateItem.html)}
          </div>
        </div>
      ))}
    </>
  );
}
